import React, { memo } from 'react';
import { TextField } from '@mui/material';

const MemoTextField = memo((props: React.ComponentProps<typeof TextField>) => {
  return <TextField {...props} />;
});

MemoTextField.displayName = 'MemoTextField';

export { MemoTextField };
